import React from 'react';
import './VIPServices.css';

const VIPServices = () => {
  const services = [
    {
      id: 1,
      icon: '🏥',
      title: 'Department of Africa Health & Services',
      description: 'ABVIG partnership with ASPI, in collaboration with the Federal Ministry of Health Nigeria, Ministry of Health Ghana (Ghana Health Service) & other International Health Partners including USAID, Project C.U.R.E., Maycha Global Ltd, WFP, etc.',
      features: [
        'Hospital Facility Refurbishment',
        'Medical Equipment & Post-COVID-19 Supplies',
        'Health Education Services',
        'Project Development & Management',
        'HSE & Safety Services'
      ],
      image: 'https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=600&h=400&fit=crop',
      link: '/africa-health-services',
      contact: {
        phone: ['+234 905 625 5065', '+234 703 294 1519', '+234 814 263 8552'],
        email: 'info@asp-i.org',
        website: 'www.asp-i.org',
        address: 'No. 2 Mungo Park Close, Hampton Apartment, Off Onitsha Crescent, Area 11, Asokoro, Abuja, FCT'
      }
    },
    {
      id: 2,
      icon: '📄',
      title: 'Company Registrations',
      description: 'Fast, reliable company registration services across Nigeria, Ghana, and other jurisdictions. We make registration easy, fast, and reliable.',
      features: [
        'CAC Certificate of Incorporation',
        'Certified True Copy of Memorandum & Articles of Association',
        'Certified True Copy of Form',
        'Bonuses',
        'Company Logo Design (Only)',
        'Company Letter Head Design (Only)',
        'Complimentary Card Design (Only)',
        'Business Names/Enterprise Registration',
        'NGO, Churches, Mosques, Schools, Associations Registration'
      ],
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop',
      link: '/contact-us',
      contact: {
        phone: ['+234 905 625 5063', '+234 703 294 1519'],
        email: 'info@abvig.com',
        website: 'www.abvig.com',
        address: 'No. 2 Mungo Park Close, Hampton Apartment, Off Onitsha Crescent, Area 11, Asokoro, Abuja, FCT'
      }
    },
    {
      id: 3,
      icon: '✈️',
      title: 'Aircraft/Private Jets Sales & Lease',
      description: 'No.1 Aircraft Sales Mart offering comprehensive aviation solutions for commercial and private needs.',
      features: [
        'Commercial lease & sales',
        'Business jets sales',
        'Helicopter sales',
        'Aircraft Engines / APU / Sales / Lease / Exchange',
        'Aircraft trust registration',
        'Offshore aircraft registration',
        'Ferry flight',
        'Crew support'
      ],
      image: 'https://images.unsplash.com/photo-1542296332-2e4473faf563?w=600&h=400&fit=crop',
      link: '/aircraft-application',
      contact: {
        phone: ['+234 905 625 5065', '+234 703 294 1519', '+234 814 263 8552'],
        email: 'info@abvig.com',
        website: 'www.abvig.com',
        address: 'No. 2 Mungo Park Close, Hampton Apartments, Off Onitsha Crescent, Area 11, Asokoro, Abuja, FCT'
      }
    },
    {
      id: 4,
      icon: '🏠',
      title: 'ABVIG Real Estate Development',
      description: 'Exquisite decoration assurance with premium property solutions for modern living.',
      features: [
        '3 Bedroom & 2 Bedroom Apartments',
        'Open Kitchen',
        'Guest Room',
        'Swimming Pool',
        'Car Garages',
        '2 Dining Room',
        'Rear Garden',
        '30% DISCOUNT'
      ],
      image: '/images/real-estate.png',
      link: '/contact-us',
      contact: {
        phone: ['+234 905 625 5065', '+234 703 294 1519', '+234 814 263 0552'],
        email: 'info@abvig.com',
        website: 'www.abvig.com',
        address: 'No. 2 Mungo Park Close, Hampton Apartment, Off Onitsha Crescent, Area 11, Asokoro, Abuja, FCT'
      }
    },
    {
      id: 5,
      icon: '⚡',
      title: 'Department of Power & Energy Infrastructure',
      description: 'In Partnership with Schaffer Faulkner Nig. Ltd. Providing comprehensive energy solutions.',
      features: [
        'Renewable Energy',
        'Oil & Gas Infrastructure/Facilities',
        'Automotive/Mechanical Engineering',
        'Power Project Funding Prospecting'
      ],
      image: '/images/power-cp.png',
      link: '/contact-us',
      contact: {
        phone: ['+234 703 294 1519', '+234 905 625 5063', '+234 803 323 2356'],
        email: 'info@abvig.com',
        website: 'www.abvig.com',
        address: 'No. 2 Mungo Park Close, Hampton Apartment, Off Onitsha Crescent, Area 11, Asokoro, Abuja, FCT'
      }
    },
    {
      id: 6,
      icon: '🚛',
      title: 'Department of Transportation & Logistics',
      description: 'Comprehensive transportation and logistics solutions for businesses and individuals.',
      features: [
        'Transportation/Rental Services',
        'Heavy Marine & Earth Moving Equipment Supply',
        'Haulage, Goods & Services',
        'Mining Sector Support Services',
        'Special Lease & Hire Purchase Programme'
      ],
      image: '/images/trp-loh.png',
      link: '/transportation-logistics',
      contact: {
        phone: ['+234 703 294 1519', '+234 905 625 5063'],
        email: 'info@abvig.com',
        website: 'www.abvig.com',
        address: 'No. 2 Mungo Park Close, Hampton Apartment, Off Onitsha Crescent, Area 11, Asokoro, Abuja, FCT'
      }
    },
    {
      id: 7,
      icon: '🛂',
      title: 'General Immigration Service',
      description: 'Helping you move to your dream destination with professional immigration assistance.',
      features: [
        'Visa Application/Processing',
        'Passport Processing',
        'Travel Document Assistance'
      ],
      image: '/images/immigration.png',
      link: '/contact-us',
      contact: {
        phone: ['+234 905 625 5065', '+234 703 294 1519', '+234 814 263 8552'],
        email: 'info@abvig.com',
        website: 'www.abvig.com',
        address: 'No. 2 Mungo Park Close, Hampton Apartment, Off Onitsha Crescent, Area 11, Asokoro, Abuja, FCT'
      }
    }
  ];

  const partners = [
    { name: 'Federal Ministry of Health Nigeria', icon: '🏛️' },
    { name: 'Ministry of Health Ghana', icon: '🏛️' },
    { name: 'USAID', icon: '🇺🇸' },
    { name: 'Project C.U.R.E.', icon: '❤️' },
    { name: 'Maycha Global Ltd', icon: '🌐' },
    { name: 'WFP', icon: '🍲' },
    { name: 'Schaffer Faulkner Nig. Ltd', icon: '⚡' },
    { name: 'Federal Ministry of Industry, Trade & Investment', icon: '🏛️' }
  ];

  const handleCardClick = (link) => {
    if (link) {
      window.location.href = link;
    }
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="page-hero">
        <h1>VIP Services</h1>
        <p>Premium business solutions for distinguished clients</p>
      </section>

      {/* Services Grid */}
      <section className="vip-services-grid-section">
        <div className="container">
          <h2 className="section-title">Our VIP Services</h2>
          <div className="vip-services-grid">
            {services.map((service) => (
              <div 
                className="vip-service-card" 
                key={service.id}
                onClick={() => handleCardClick(service.link)}
                style={{ cursor: service.link ? 'pointer' : 'default' }}
              >
                <div 
                  className="vip-service-image" 
                  style={{backgroundImage: `url(${service.image})`}}
                ></div>
                <div className="vip-service-body">
                  <div className="vip-service-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p className="vip-service-description">{service.description}</p>
                  <ul className="vip-service-features">
                    {service.features.map((feature, index) => (
                      <li key={index}>✓ {feature}</li>
                    ))}
                  </ul>
                  {service.contact && (
                    <div className="vip-service-contact">
                      {service.contact.phone && (
                        <div className="contact-item">
                          <span>📞</span>
                          <div>
                            {service.contact.phone.map((phone, i) => (
                              <p key={i}>{phone}</p>
                            ))}
                          </div>
                        </div>
                      )}
                      {service.contact.email && (
                        <div className="contact-item">
                          <span>✉️</span>
                          <p>{service.contact.email}</p>
                        </div>
                      )}
                      {service.contact.website && (
                        <div className="contact-item">
                          <span>🌐</span>
                          <p>{service.contact.website}</p>
                        </div>
                      )}
                      {service.contact.address && (
                        <div className="contact-item address">
                          <span>📍</span>
                          <p>{service.contact.address}</p>
                        </div>
                      )}
                    </div>
                  )}
                  {service.link && (
                    <span className="service-link-text">Click to Learn More →</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="vip-partners">
        <div className="container">
          <h2 className="section-title">Our Partners</h2>
          <div className="vip-partners-grid">
            {partners.map((partner, index) => (
              <div className="vip-partner-card" key={index}>
                <span className="partner-icon">{partner.icon}</span>
                <p>{partner.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="vip-cta">
        <div className="container">
          <div className="vip-cta-content">
            <h2>Contact Our VIP Services Team</h2>
            <p>
              For premium business solutions, company registrations, or health services, 
              reach out to our dedicated team.
            </p>
            <div className="vip-cta-contact">
              <div>
                <span>📞</span>
                <p>+234 905 625 5065<br />+234 703 294 1519</p>
              </div>
              <div>
                <span>✉️</span>
                <p>info@abvig.com</p>
              </div>
              <div>
                <span>🌐</span>
                <p>www.abvig.com</p>
              </div>
            </div>
            <button 
              className="btn-gold" 
              onClick={() => window.location.href = '/contact-us'}
            >
              Contact Us Now
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VIPServices;